import { APP_BASE_HREF, CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPermissionsModule } from 'ngx-permissions';

import { AppComponent } from './app.component';
import { AuthModule } from './auth.module';
import { UtilityModule } from './utility';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { UserIdleModule } from 'angular-user-idle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InactiveModalComponent } from './inactive-modal.component';
import { MinuteSecondsPipe } from './shared/pipe/minute-seconds.pipe';
import { LoaderComponent } from './core/loader/loader.component';
import { DxLoadIndicatorModule, DxLoadPanelModule } from 'devextreme-angular';
import { GlobalErrorHandler } from './core/errorHandeler/error-handler.service';
@NgModule({
  declarations: [
	AppComponent,
	InactiveModalComponent,
	MinuteSecondsPipe,
	LoaderComponent
  ],
  imports: [
	BrowserModule,
	ReactiveFormsModule,
	FormsModule,
	CommonModule,
	NgbModule,
	// AppRoutingModule,
	UtilityModule,
	NgxPermissionsModule.forRoot(),
	// UserIdleModule.forRoot({ idle: 900, timeout: 300, ping: 120 }), // idle: 900, timeout: 300, ping: 120
	AuthModule,
	DxLoadPanelModule,
	DxLoadIndicatorModule,
  ],
  providers: [
	{ provide: LocationStrategy, useClass: HashLocationStrategy },
	{ provide: ErrorHandler, useClass: GlobalErrorHandler },
	// {
	//   provide: HTTP_INTERCEPTORS,
	//   useClass: AppHttpInterceptor,
	//   multi: true
	// },
	{ provide: APP_BASE_HREF, useValue: '/' }
  ],
  bootstrap: [AppComponent],
  entryComponents: [InactiveModalComponent]
})
export class AppModule { }
